import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'
import { ERRO_INESPERADO } from '@modules/aawz-intelligence-v2/api/guardas'

const ERRO_CONVERSA_OBRIGATORIA = 'conversationId obrigatório'
const ERRO_FEEDBACK_INCOMPLETO = 'conversationId e messageId obrigatórios'

class APIMessages extends APITemplate {
  async getMessages({ conversationId } = {}) {
    if (!conversationId) return this.buildErrorResponse({ message: ERRO_CONVERSA_OBRIGATORIA, status: 400 })
    const r = await con.get(intelligenceV2.conversationMessages(conversationId))
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  // `comentario` (spec-011 T003, AC2.1): opcional, <=2000 chars — o backend
  // ja aceita (`resource_feedback.py:79-89`, migration v634); so' entra no
  // corpo quando o front tiver algo pra mandar, pra bater com a regra do
  // servidor de "ausencia preserva o valor ja gravado" em vez de sobrescrever
  // com null.
  async saveFeedback({ conversationId, messageId, feedback, comentario } = {}) {
    // Guard ANTES da URL: sem ele `conversationId` ausente vira
    // `/conversations/undefined/feedback` chegando ao backend.
    if (!conversationId || !messageId) {
      return this.buildErrorResponse({ message: ERRO_FEEDBACK_INCOMPLETO, status: 400 })
    }
    const body = {
      message_id: messageId,
      feedback,
    }
    if (comentario) body.comentario = comentario
    const r = await con.post(intelligenceV2.feedback(conversationId), body)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

export const apiMessages = new APIMessages()
